import { render, staticRenderFns } from "./VMenuDishItemDetails.vue?vue&type=template&id=38b42e04&scoped=true&"
import script from "./VMenuDishItemDetails.vue?vue&type=script&lang=js&"
export * from "./VMenuDishItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./VMenuDishItemDetails.vue?vue&type=style&index=0&id=38b42e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b42e04",
  null
  
)

export default component.exports